import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, CompanyDataService, CompanyData, ModelData, ModalSize, ModalService, YtKontrolaJmbg, KJSDataService, KJSData, NotificationService } from 'yt-ng-framework';
import { Company } from './company';
import { ActivatedRoute } from '@angular/router';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Validators, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TipKomitenta } from 'src/app/lookups/tip-komitenta/tip-komitenta';
import { CompanyUvozNBS } from './company-uvoz-nbs/company-uvoz-nbs';
import { CompanyEmail } from './company-email/company-email';
import { CompanyZrc } from './company-zrc/company-zrc';
import { CompanyTelefon } from './company-telefon/company-telefon';
import { CompanyUvozNbsComponent } from './company-uvoz-nbs/company-uvoz-nbs.component';
import { Banka } from 'src/app/lookups/banka/banka';
import { Mesto } from 'src/app/lookups/mesto/mesto';
import { PostaviOdgovornoLiceComponent } from './postavi-odgovorno-lice/postavi-odgovorno-lice.component';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-company-update',
  templateUrl: './company-update.component.html'
})
export class CompanyUpdateComponent extends BaseUpdateComponent<Company> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected companyDataService : CompanyDataService,
    protected modalService: ModalService,
    protected kjsDataService: KJSDataService,
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService, modalService);
  }

  checkPib:boolean = false;
  checkMaticniBroj:boolean = false;
  loadingCompanyData:boolean = false;
  loadingCompanyDataByPib:boolean = false;
  loadingCompanyDataByMB:boolean = false;
  companyId:number;

  @ViewChild('tabSet', { static: true }) tabset: any;
  mestoNaziv: string = "";
  companyUvozNbs : CompanyUvozNBS[];

  postojeceOdgLice: any;
  novoOdgLice: any;
  parameterList: List<QueryParameter> = List([]);
  FirmaID: QueryParameter = new QueryParameter();


  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'FIRMA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'FIRMA.NAZIV.VALIDATION.MAXLENGTH');
    // this.addValidatorToFc("Pib", Validators.required, 'required', 'FIRMA.PIB.VALIDATION.REQUIRED');
    this.addValidatorToFc("Pib", Validators.maxLength(9), 'maxlength', 'FIRMA.PIB.VALIDATION.MAXLENGTH');
    // this.addValidatorToFc("MaticniBroj", Validators.required, 'required', 'FIRMA.MATICNIBROJ.VALIDATION.REQUIRED');
    this.addValidatorToFc("MaticniBroj", Validators.maxLength(8), 'maxlength', 'FIRMA.MATICNIBROJ.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Adresa", Validators.required, 'required', 'FIRMA.ADRESA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Adresa", Validators.maxLength(200), 'maxlength', 'FIRMA.ADRESA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("MestoID", Validators.required, 'required', 'FIRMA.MESTO.VALIDATION.REQUIRED');
    this.addValidatorToFc("LanguageID", Validators.required, 'required', 'FIRMA.JEZIK.VALIDATION.REQUIRED');
    this.addValidatorToFc("TipKomitentaID", Validators.required, 'required', 'FIRMA.TIPKOMITENTA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Jmbg", Validators.maxLength(13), 'maxlength', 'FIRMA.JMBG.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Jmbg",YtKontrolaJmbg, 'jmbgControl', 'FW.KONTROLAPOMODULU.VALIDATION.MODUL11');
    this.addValidatorToFc("BrojGazdinstva", Validators.maxLength(30), 'maxlength', 'FIRMA.BROJGAZDINSTVA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("PdvBroj", Validators.maxLength(15), 'maxlength', 'FIRMA.PDVBROJ.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SNaziv", Validators.required, 'required', 'FIRMA.SNAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("SNaziv", Validators.maxLength(100), 'maxlength', 'FIRMA.SNAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("ValutaID", Validators.required, 'required', 'FIRMA.VALUTA.VALIDATION.REQUIRED');

    this.baseFormGroup.setValidators(CheckByTipKomitenta('TipKomitentaID','Pib','MaticniBroj','Jmbg','BrojGazdinstva'));
    this.baseFormGroup.updateValueAndValidity();

    this.FirmaID.Value = -1
    this.FirmaID.Name= "firmaid";
    this.parameterList = this.parameterList.push(this.FirmaID);


    this.IDProcessed
    .subscribe((value) => {
        if(value){
        if (this.Item.ID == -1){
          this.tabset.select('tbList');
          this.baseFormGroup.get('OdgovornoLiceID').disable();
        } 
        else {
            this.baseFormGroup.get('OdgovornoLiceID').enable();
            this.postojeceOdgLice = this.baseFormGroup.get('OdgovornoLiceID').value == null ? 0 : this.baseFormGroup.get('OdgovornoLiceID').value;
            this.companyId = this.Item.ID;

            this.FirmaID.Value = this.Item.ID;//this.Item.ID;
            this.FirmaID.Name= "firmaid";
            this.parameterList = this.parameterList.push(this.FirmaID);
        }
        this.baseFormGroup.get('OdgovornoLiceID').updateValueAndValidity();
    }
    });

    this.ItemSaved
        .subscribe((value) => {
            if(value){
            this.novoOdgLice = value.OdgovornoLiceID;
            if(this.postojeceOdgLice != this.novoOdgLice){
                let modelData = new ModelData(null);
                modelData.ModalSize = ModalSize.Md;
                modelData.UpdateComponent = PostaviOdgovornoLiceComponent;
            
                let odgovornoLiceID: number = this.baseFormGroup.get('OdgovornoLiceID').value;
                let odgovornoLiceIDParameter = new QueryParameter('OdgovornoLiceID', odgovornoLiceID);
                let companyId: number = this.companyId;
                let companyIDParameter = new QueryParameter('CompanyID', companyId);
            
                if(modelData){
                  this.modalService.ShowModal(0, modelData, null, true, [
                     odgovornoLiceIDParameter,
                     companyIDParameter
                  ])
                  .result.then( result => {
                    // this.komBaseUpdate.SetFirmaKodKupca = result;
                  },
                  () =>{})
                }
            }
            }
        })
  }

  ngAfterViewInit(){
    this.IDProcessed
    .subscribe((value) => {
        if (this.Item.ID == -1){
          this.tabset.select('tbList');
          this.baseFormGroup.get('Jmbg').disable();
          this.baseFormGroup.get('Jmbg').updateValueAndValidity();
          this.baseFormGroup.get('BrojGazdinstva').disable();
          this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();

        }
    });
 }

  onTipKomitentaSelect(value:TipKomitenta){
    if (value==null ){
        this.baseFormGroup.get('Pib').disable();
        this.baseFormGroup.get('Pib').updateValueAndValidity();
        this.baseFormGroup.get('MaticniBroj').disable();
        this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
        this.baseFormGroup.get('Jbkjs').disable();
        this.baseFormGroup.get('Jbkjs').updateValueAndValidity();
        this.baseFormGroup.get('Jmbg').disable();
        this.baseFormGroup.get('Jmbg').updateValueAndValidity();
        this.baseFormGroup.get('BrojGazdinstva').disable();
        this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();
    }
    if (value!=null && value.GenericName=="PD"){
        this.baseFormGroup.get('Pib').enable();
        this.baseFormGroup.get('Pib').updateValueAndValidity();
        this.baseFormGroup.get('MaticniBroj').enable();
        this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
        this.baseFormGroup.get('Jbkjs').enable();
        this.baseFormGroup.get('Jbkjs').updateValueAndValidity();
        this.baseFormGroup.patchValue({Jmbg:null, BrojGazdinstva:null});
        this.baseFormGroup.get('Jmbg').disable();
        this.baseFormGroup.get('Jmbg').updateValueAndValidity();
        this.baseFormGroup.get('BrojGazdinstva').disable();
        this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();
    }

    if (value!=null && value.GenericName=="PG"){
        this.baseFormGroup.patchValue({Pib:null, MaticniBroj:null});
        this.baseFormGroup.get('Pib').disable();
        this.baseFormGroup.get('Pib').updateValueAndValidity();
        this.baseFormGroup.get('MaticniBroj').disable();
        this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
        this.baseFormGroup.get('Jbkjs').disable();
        this.baseFormGroup.get('Jbkjs').updateValueAndValidity();
        this.baseFormGroup.get('Jmbg').enable();
        this.baseFormGroup.get('Jmbg').updateValueAndValidity();
        this.baseFormGroup.get('BrojGazdinstva').enable();
        this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();
    }

    if (value!=null && value.GenericName=="Ostalo"){
        this.baseFormGroup.get('Pib').enable();
        this.baseFormGroup.get('Pib').updateValueAndValidity();
        this.baseFormGroup.get('MaticniBroj').enable();
        this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
        this.baseFormGroup.get('Jbkjs').enable();
        this.baseFormGroup.get('Jbkjs').updateValueAndValidity();
        this.baseFormGroup.get('Jmbg').enable();
        this.baseFormGroup.get('Jmbg').updateValueAndValidity();
        this.baseFormGroup.get('BrojGazdinstva').enable();
        this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();
    }
}

GetCompanyDataByPibNovo(){
    if(!this.baseFormGroup.get('Pib').value || this.baseFormGroup.get('Pib').value == '' || this.fc.Pib.invalid){
        this.checkPib = true;
        this.translateService.get(['NBS.PIB.WARNING'])
            .subscribe(translate => {
                // this.notificationsService.alert(translate['NBS.PIB.WARNING']);
                this.toastrService.warning(translate['NBS.PIB.WARNING']);
                return;
            });
    }    
    else{
        this.baseDataService.Get("firma","getIDfromUslov",[new QueryParameter('uslov', "pib = '" + this.baseFormGroup.get('Pib').value + "'")],Company)
        .subscribe((result) =>{
            if (Number(result) > 0){
                this.translateService.get(['NBS.PIB.EXIST'])
                .subscribe(translate => {
                    // this.notificationsService.alert(translate['NBS.PIB.EXIST']);
                    this.toastrService.info(translate['NBS.PIB.EXIST']);
                    return;
                });
            }
            else{
                this.loadingCompanyDataByPib = true;
                this.companyDataService.GetCompanyDataByTaxNo(this.baseFormGroup.get('Pib').value)
                .subscribe((data: CompanyData[]) => {
                    this.loadingCompanyDataByPib = false;
                    if(data.length == 0){
                        this.translateService.get(['NBS.PIB.WARNING'])
                          .subscribe(translate => {
                            // this.notificationsService.alert(translate['NBS.PIB.WARNING']);
                            this.toastrService.warning(translate['NBS.PIB.WARNING']);
                            return;
                          });
                    }
                    else{
                        //ovde treba poziv modalne forme sa onim što smo dobili od podataka.
                        this.kjsDataService.GetByPib(data[0].TaxIdentificationNumber)
                        .subscribe((kjsData: KJSData[]) => {
                            this.podesavanjeUvozNBS(data, "Pib", kjsData != null ? kjsData[0].Jbbk : "");
                        });                
                    }
                })
            }
        });
        
        
    }
}

    GetCompanyDataByMatBrNovo(){
        if(!this.baseFormGroup.get('MaticniBroj').value || this.baseFormGroup.get('MaticniBroj').value == '' || this.fc.MaticniBroj.invalid){
            this.checkMaticniBroj = true;
            this.translateService.get(['NBS.MATICNIBROJ.WARNING'])
                  .subscribe(translate => {
                    //   this.notificationsService.alert(translate['NBS.MATICNIBROJ.WARNING']);
                      this.toastrService.warning(translate['NBS.MATICNIBROJ.WARNING']);
                      return;
                  });
        }  
        else{  
            this.baseDataService.Get("firma","getIDfromUslov",[new QueryParameter('uslov', "maticni_broj = '" + this.baseFormGroup.get('MaticniBroj').value + "'")],Company)
            .subscribe((result) =>{
                if (Number(result) > 0){
                    this.translateService.get(['NBS.MATICNIBROJ.EXIST'])
                    .subscribe(translate => {
                        // this.notificationsService.alert(translate['NBS.MATICNIBROJ.EXIST']);
                        this.toastrService.info(translate['NBS.MATICNIBROJ.EXIST']);
                        return;
                    });
                }
                else{
                    this.loadingCompanyDataByMB = true;
                    this.companyDataService.GetCompanyDataByNationalIdentificationNo(this.baseFormGroup.get('MaticniBroj').value)
                    .subscribe((data: CompanyData[]) => {
                        this.loadingCompanyDataByMB = false;
                        if(data.length == 0){
                            this.translateService.get(['NBS.MATICNIBROJ.WARNING'])
                              .subscribe(translate => {
                                // this.notificationsService.alert(translate['NBS.MATICNIBROJ.WARNING']);
                                this.toastrService.warning(translate['NBS.MATICNIBROJ.WARNING']);
                                return;
                              });
                        }
                        else{
                            //ovde treba poziv modalne forme sa onim što smo dobili od podataka.
                            this.kjsDataService.GetByMb(this.baseFormGroup.get('MaticniBroj').value)
                            .subscribe((kjsData: KJSData[]) => {
                                this.podesavanjeUvozNBS(data, "MB", kjsData != null ? kjsData[0].Jbbk : "");  
                            });                      
                        }
                    })
                }
            });
       
          }
      }

      setCompanyDataNovo(data:CompanyData, ID: number, jbkjs: string) {
        let companyUvozNbs : CompanyUvozNBS= new CompanyUvozNBS();
        let companyUvozNbsObj : CompanyUvozNBS[]= [];
        let conmpanyEmail : CompanyEmail = new CompanyEmail();
        let companyEmailObj : CompanyEmail[] = [];
        // let komitentZrc : KomitentZrc = new KomitentZrc();
        let companyZrcObj : CompanyZrc[] = [];
        // let komitentTelefon : KomitentTelefon = new KomitentTelefon();
        let companyTelefonObj : CompanyTelefon[] = [];
    
        companyUvozNbs.ID = ID;
        companyUvozNbs.Naziv = data.Name;
        companyUvozNbs.SNaziv = data.ShortName;
        companyUvozNbs.MaticniBroj = data.NationalIdentificationNumber;
        companyUvozNbs.Pib = data.TaxIdentificationNumber;
        companyUvozNbs.Adresa = data.Address;
        companyUvozNbs.MestoID = data["CityID"];
        companyUvozNbs.Jbkjs = jbkjs;
    
        if (data.Email != "" && data.Email != null){
            conmpanyEmail.Naziv = data.Email;
            conmpanyEmail.Glavni = true;
            conmpanyEmail.FirmaID = ID;
            companyEmailObj.push(conmpanyEmail);
            companyUvozNbs.Emaili = companyEmailObj;
         
        }
    
        if (data.Phone != "" && data.Phone != null){
            let companyTelefon : CompanyTelefon = new CompanyTelefon();
            companyTelefon.Broj = data.Phone;
            companyTelefon.Glavni = true;
            companyTelefon.FirmaID = ID;
            companyTelefonObj.push(companyTelefon);
            companyUvozNbs.Telefoni = companyTelefonObj;
            
        }
    
        if (data.Phone2 != "" && data.Phone2 != null){
            let companyTelefon : CompanyTelefon = new CompanyTelefon();
            companyTelefon.Broj = data.Phone2;
            companyTelefon.FirmaID = ID;
            companyTelefonObj.push(companyTelefon);
            companyUvozNbs.Telefoni = companyTelefonObj;
           
        }
    
        let index = 0; 
        data.AccountNumbers.forEach(zrc => {
            let companyZrc : CompanyZrc = new CompanyZrc();
            zrc = zrc.replace(/-/g,"");
            
            companyZrc.Zrc1=zrc.substr(0,3).trim();
            companyZrc.Zrc2=zrc.substr(3,zrc.length-5).trim();
            companyZrc.Zrc3=zrc.substr(zrc.length-2,2).trim();
            companyZrc.Zrc=companyZrc.Zrc1 +'-'+ companyZrc.Zrc2 +'-'+ companyZrc.Zrc3;
            // komitentZrc.Zrc = zrc;
            this.baseDataService.Get("banka","getIDfromUslov",[new QueryParameter('uslov', "sifra = '"+zrc.substr(0,3)+"'")],Banka)
            .subscribe((result) =>{
                if (result)
                companyZrc.BankaID = Number(result);
            })
            if(index == 0)
            companyZrc.Glavni = true;
            index ++;
            companyZrc.FirmaID = ID;
            companyZrcObj.push(companyZrc);
            companyUvozNbs.ZiroRacuni = companyZrcObj;
        });
    
        companyUvozNbsObj.push(companyUvozNbs);
        this.companyUvozNbs = companyUvozNbsObj;
        return this.companyUvozNbs;
      }

    

podesavanjeUvozNBS(data : CompanyData[], vrsta : string, jbkjs: string){
    if (vrsta == "MB")
        this.loadingCompanyDataByMB = true;
    else
        this.loadingCompanyDataByPib = true;

    let emailNazivConfig = {
        formControlName: 'Email',
        label: 'FIRMAEMAIL.NAZIV.SINGULAR'
    }

    let glavniEmailConfig = {
        formControlName: 'Glavni',
        label: 'FIRMAEMAIL.GLAVNI.SINGULAR'
    }

    let svojinaEmailConfig = {
        modelName: 'svojina',
        getName: 'get',
        modelProperty: 'Naziv',
        orderBy: 'Naziv',
        formControlName: 'SvojinaID',
        label: 'FIRMAEMAIL.SVOJINA.SINGULAR',
        allowAddNew: false,
        width: 'xl',
        position: 'left'
    }
    
    let emailOpisConfig = {
        formControlName: 'Opis',
        label: 'FIRMAEMAIL.OPIS.SINGULAR'
    }

    let vrstaTelefonaConfig = {
        modelName: 'vrstatelefona',
        getName: 'get',
        modelProperty: 'Naziv',
        orderBy: 'Naziv',
        formControlName: 'VrstaTelefonaID',
        label: 'FIRMATELEFON.VRSTATELEFONA.SINGULAR',
        allowAddNew: false,
        width: 'xl',
        position: 'left'
    }

    let brojTelefonaConfig = {
        formControlName: 'Broj',
        label: 'FIRMATELEFON.BROJ.SINGULAR'
    }

    let lokalTelefonaConfig = {
        formControlName: 'Lokal',
        label: 'FIRMATELEFON.LOKAL.SINGULAR'
    }

    let glavniTelefonConfig = {
        formControlName: 'Glavni',
        label: 'FIRMATELEFON.GLAVNI.SINGULAR'
    }

    let svojinaTelefonConfig = {
        modelName: 'svojina',
        getName: 'get',
        modelProperty: 'Naziv',
        orderBy: 'Naziv',
        formControlName: 'SvojinaID',
        label: 'FIRMATELEFON.SVOJINA.SINGULAR',
        allowAddNew: false,
        width: 'xl',
        position: 'left'
    }

    let opisTelefonaConfig = {
        formControlName: 'Opis',
        label: 'FIRMATELEFON.OPIS.SINGULAR'
    }

    let zrcConfig = {
        formControlName: 'Zrc',
        label: 'FIRMAZRC.ZRC.SINGULAR'                   
    }

    let glavniZrcConfig = {
        formControlName: 'Glavni',
        label: 'FIRMAZRC.GLAVNI.SINGULAR'
    }

    let bankaTelefonConfig = {
        modelName: 'banka',
        getName: 'get',
        modelProperty: 'Naziv',
        orderBy: 'Naziv',
        formControlName: 'BankaID',
        label: 'FIRMAZRC.BANKA.SINGULAR',
        allowAddNew: false,
        width: 'xl',
        position: 'left'
    }

    let emailgridConfig = [
        {name: 'Email', label: 'FIRMAEMAIL.NAZIV.SINGULAR', type: 'input', config: emailNazivConfig, disabled: false, required : 'true', width:'30%'}
        ,{name: 'Glavni', label: 'FIRMAEMAIL.GLAVNI.SINGULAR', type: 'checkbox', config: glavniEmailConfig, disabled: true, width:'10%'}
        ,{name: 'SvojinaID', label: 'FIRMAEMAIL.SVOJINA.SINGULAR', type: 'DDL', config: svojinaEmailConfig, disabled: false, required : 'true', width:'30%'}
        ,{name: 'Opis', label: 'FIRMAEMAIL.OPIS.SINGULAR', type: 'input', config: emailOpisConfig, disabled: false, width:'30%'}
    ];

    let telefongridConfig = [
        {name: 'VrstaTelefonaID', label: 'FIRMATELEFON.VRSTATELEFONA.SINGULAR', type: 'DDL', config: vrstaTelefonaConfig, disabled: false, required : 'true', width:'15%'}
        ,{name: 'Broj', label: 'FIRMATELEFON.BROJ.SINGULAR', type: 'input', config: brojTelefonaConfig, disabled: true, required : 'true', width:'30%'}
        ,{name: 'Lokal', label: 'FIRMATELEFON.LOKAL.SINGULAR', type: 'input', config: lokalTelefonaConfig, disabled: true, width:'5%'}
        ,{name: 'Glavni', label: 'FIRMATELEFON.GLAVNI.SINGULAR', type: 'checkbox', config: glavniTelefonConfig, disabled: true, width:'10%'}
        ,{name: 'SvojinaID', label: 'FIRMATELEFON.SVOJINA.SINGULAR', type: 'DDL', config: svojinaTelefonConfig, disabled: false, required : 'true', width:'15%'}
        ,{name: 'Opis', label: 'FIRMATELEFON.OPIS.SINGULAR', type: 'input', config: opisTelefonaConfig, disabled: true, width:'25%'}
    ];
    
    let ziroracungridConfig = [
        {name: 'Zrc', label: 'FIRMAZRC.ZRC.SINGULAR', type: 'ZRC', config: zrcConfig, disabled: 'true', required : 'true', width:'50%'}
        ,{name: 'Glavni', label: 'FIRMAZRC.GLAVNI.SINGULAR', type: 'checkbox', config: glavniZrcConfig, disabled: true, width:'10%'}
        ,{name: 'BankaID', label: 'FIRMAZRC.BANKA.SINGULAR', type: 'DDL', config: bankaTelefonConfig, disabled: false, required : 'true', width:'40%'}
    ];

    let emailgridParameter = new QueryParameter("emailgrid",emailgridConfig);
    let telefongridParameter = new QueryParameter("telefongrid",telefongridConfig);
    let ziroracungridParameter = new QueryParameter("ziroracungrid",ziroracungridConfig);

    // var komitentUvozNbs : List<KomitentUvozNBS>;
    this.setCompanyDataNovo(data[0], this.Item.ID, jbkjs);
    let companyUvozNbsParameter = new QueryParameter("companyUvozNbs",this.companyUvozNbs);
    // this.komitentUvozNbs[0].ID = this.Item.ID;

    let modelData = new ModelData(null);
    modelData.ModalSize = ModalSize.Xl;
    modelData.UpdateComponent = CompanyUvozNbsComponent;

    if (vrsta == "MB")
        this.loadingCompanyDataByMB = false;
    else
        this.loadingCompanyDataByPib = false;

    this.modalService.ShowModal(this.Item.ID, modelData, null, true, [companyUvozNbsParameter, emailgridParameter, telefongridParameter, ziroracungridParameter])
        .result
        .then((result) => {
            if (result && result>0)
            {
                this.baseDataService.GetByID("firma",result,Company)
                    .subscribe((data: Company) =>{                                    
                        this.Item = data;
                        this.baseFormGroup.setValue(this.Item);
                        this.SavedItem = this.Item;
                        this.baseFormGroup.get('OdgovornoLiceID').enable();
                        this.baseFormGroup.get('OdgovornoLiceID').updateValueAndValidity();
                    })
            }
            else
                this.translateService.get(['NBS.CANCEL'])
                    .subscribe(translate => {
                        // this.notificationsService.alert(translate['NBS.CANCEL']);
                        this.toastrService.info(translate['NBS.CANCEL']);
                        return;
                    });
        })
}  

onMestoSelected(value:Mesto){
    this.mestoNaziv = value.Naziv;
}
  onRestoreClick(): void {
    this.Reset(true).subscribe((result) => {
      if (result) {
        // console.log('Restore successfully executed');
      } else {
        // console.log('Restore was cancelled by the user');
      }
    });
  }
}
function CheckByTipKomitenta(tipKomitentaIDKey:string, pibKey: string, maticniBrojKey: string, jmbgKey: string, brojGazdinstvaKey: string){
  return (group: FormGroup): {[key : string]: any} =>{
   let tipKomitenaID = group.controls[tipKomitentaIDKey].value;
   let pib = group.controls[pibKey].value;
   let maticniBroj = group.controls[maticniBrojKey].value;
   let jmbg = group.controls[jmbgKey].value;
   let brojGazdinstva = group.controls[brojGazdinstvaKey].value;
   if (tipKomitenaID==null && pib==null && maticniBroj==null)
       return { checkControls :{valid:true, message:'ok'}};
   if (tipKomitenaID==1 && (pib=="" || maticniBroj=="" || pib==null || maticniBroj==null))
       return { checkControls :{valid:false, message: 'FIRMA.TIPKOMITENTA.PRIVREDNODRUSTVO.VALIDATION'}};
   if (tipKomitenaID==2 && (jmbg=="" || brojGazdinstva=="" || jmbg==null || brojGazdinstva ==null))
       return { checkControls :{valid:false, message: 'FIRMA.TIPKOMITENTA.GAZDINSTVO.VALIDATION'}};
   // if (tipKomitenaID==1 && (pib=="" || maticniBroj==""))
   //     return {'checkControls':'KOMITENT.TIPKOMITENTA.PRIVREDNODRUSTVO.VALIDATION'};
   // if (tipKomitenaID==2 && (jmbg=="" || brojGazdinstva==""))
   //     return {'checkControls':'KOMITENT.TIPKOMITENTA.GAZDINSTVO.VALIDATION'};
}
       

}
